import { KatDropdown } from '@amzn/katal-react';
import { CSSProperties } from 'react';
import styles from './StyledDropdown.module.css';

interface StyledDropdownProps extends KatDropdown.Props {
  style?: CSSProperties;
  className?: string;
}

const StyledDropdown = ({ style, className, ...katDropdownProps }: StyledDropdownProps) => {
  return (
    <div className={`${styles.container} ${className || ''}`} style={style}>
      <KatDropdown {...katDropdownProps} />
    </div>
  );
};

export { StyledDropdown };
